// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutMain_root__VKi2p"};